"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setShowOutputHelp = exports.setSort = exports.setUseTokens = void 0;
const immer_1 = require("immer");
const SET_USE_TOKENS = "sticker_order_settings.use_tokens";
const SET_SORT = "sticker_order_settings.sort";
const SET_SHOW_OUTPUT_HELP = "sticker_order_settings.show_output_help";
function setUseTokens(useTokens) {
    return {
        type: SET_USE_TOKENS,
        useTokens,
    };
}
exports.setUseTokens = setUseTokens;
const SET_SORT_LOCAL_STORAGE_KEY = "mapmaker.preferredPrintSortMethod";
function setSort(sort) {
    return {
        type: SET_SORT,
        sort,
    };
}
exports.setSort = setSort;
function setShowOutputHelp(show) {
    return {
        type: SET_SHOW_OUTPUT_HELP,
        show,
    };
}
exports.setShowOutputHelp = setShowOutputHelp;
const initialState = {
    useTokens: true,
    sort: safeGetSavedSort(),
    showOutputHelp: false,
};
exports.default = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return initialState;
    }
    switch (action.type) {
        case SET_USE_TOKENS:
            draft.useTokens = action.useTokens;
            break;
        case SET_SORT:
            draft.sort = action.sort;
            window.localStorage.setItem(SET_SORT_LOCAL_STORAGE_KEY, action.sort);
            break;
        case SET_SHOW_OUTPUT_HELP:
            draft.showOutputHelp = action.show;
            break;
        default:
            break;
    }
});
function safeGetSavedSort() {
    // Just to make sure we add any new values here.
    const StickerSortMap = {
        modified: true,
        name: true,
        timeline: true,
    };
    const savedValue = window.localStorage.getItem(SET_SORT_LOCAL_STORAGE_KEY);
    if (StickerSortMap[savedValue]) {
        return savedValue;
    }
    return "modified";
}
//# sourceMappingURL=data:application/json;base64,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